import React from 'react';
import { Badge, Button, Card } from '../ui';
import {
  ArrowPathIcon,
  BoltIcon,
  ClipboardDocumentIcon,
  FunnelIcon,
} from '@heroicons/react/24/outline';

const CommandCenterBar = ({
  focusMode,
  onToggleFocusMode,
  onRefreshNow,
  refreshing,
  onForceLivenessSweep,
  forceSweepLoading,
  onCopySummary,
  summaryCopied,
  lastLivenessCheck,
  lastProcessUpdate,
  lastAgentMessage,
}) => {
  const freshnessItems = [
    {
      id: 'liveness',
      label: 'Liveness',
      value: lastLivenessCheck || 'unknown',
      variant: lastLivenessCheck === 'unknown' ? 'yellow' : 'green',
    },
    {
      id: 'processes',
      label: 'Processes',
      value: lastProcessUpdate || 'unknown',
      variant: lastProcessUpdate === 'unknown' ? 'yellow' : 'blue',
    },
    {
      id: 'agents',
      label: 'Agent stream',
      value: lastAgentMessage || 'none yet',
      variant: lastAgentMessage === 'none yet' ? 'gray' : 'indigo',
    },
  ];

  return (
    <Card title="Command Center">
      <div className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          {freshnessItems.map((item) => (
            <Badge key={item.id} variant={item.variant} size="sm">
              {item.label}: {item.value}
            </Badge>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant={focusMode ? 'warning' : 'secondary'}
            size="sm"
            onClick={onToggleFocusMode}
            icon={FunnelIcon}
          >
            {focusMode ? 'Focus Mode: ON' : 'Focus Mode: OFF'}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            onClick={onCopySummary}
            icon={ClipboardDocumentIcon}
          >
            {summaryCopied ? 'Summary Copied' : 'Copy Ops Summary'}
          </Button>

          <Button
            variant="secondary"
            size="sm"
            onClick={onForceLivenessSweep}
            isLoading={forceSweepLoading}
            icon={BoltIcon}
          >
            Run Liveness Sweep
          </Button>

          <Button
            variant="primary"
            size="sm"
            onClick={onRefreshNow}
            isLoading={refreshing}
            icon={ArrowPathIcon}
          >
            Refresh Now
          </Button>
        </div>

        <p className="text-xs text-gray-500">
          Use Focus Mode during incidents to keep only critical blocks on screen.
        </p>
      </div>
    </Card>
  );
};

export default CommandCenterBar;
